import { render, staticRenderFns } from "./EntityManagement.vue?vue&type=template&id=4fd731ab&scoped=true&"
import script from "./EntityManagement.vue?vue&type=script&lang=js&"
export * from "./EntityManagement.vue?vue&type=script&lang=js&"
import style0 from "./EntityManagement.vue?vue&type=style&index=0&id=4fd731ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd731ab",
  null
  
)

export default component.exports